import $ from "jquery";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import BD_Block from "@bd-core/bd-block";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import CONFIG from "@bd-core/config";
import { compile } from "@bd-utils/handlerbars-helper";
import { createQuestion } from "@bd-utils/question";
import { convertHexToRgba } from "@bd-utils/convertHexToRgba";

export class Block_Image extends BD_Block {
  constructor() {
    super();

    this.type = "image";
    this.templateID = "image-template";

    this.elms = {
      playBtn: ".js-play",
      pauseBtn: ".js-pause",
      questionCard: ".questionCard",
      answer: ".js-answer",
      submit: ".js-submit",
      skip: ".js-skip",
      backWrapper: ".questionCard__back",
      back: ".js-back",
      questionCardV2: "v2-questionCard",
    };

    this._events = this.getEvents();

    /* custom attributes */
    /**
     * @type {HTMLAudioElement}
     */
    this.audio = null;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "click",
        selector: elms.back,
        handler: this.back,
      },
      {
        event: "click",
        selector: elms.submit,
        handler: this.submit,
      },
    ];
  }

  beforeInit() {
    this.render();
    this.setGameState();
    this.setupVersion3AndAbove();
  }

  setQuestion() {
    this.question = createQuestion(this._data.question);
    this._events = [...this._events, ...this.question.getEvents()];
  }

  render() {
    let templateID = this.templateID;
    if (CONFIG.siteSetup === "nuclear-quickscan") {
      templateID = "nuclear-quickscan-image-template";
    }
    const htmlTemplate = $("#" + templateID).html();
    const html = compile(htmlTemplate, this._data);
    $("#templateWrapper").html(html);
  }

  setGameState() {
    const showBackBtn = () => {
      if (Store_SequenceHistory.data) {
        $(this.elms.backWrapper).addClass("is-active");
      }
    };

    showBackBtn();
  }

  back() {
    const seqHistory = Store_SequenceHistory.data;
    // @ts-ignore
    const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID());
    const history = seqHistory[currentBlockID];
    if (!history) return;

    BD_GAME_LOGIC.goBack(history.prev);
  }

  submit() {
    BD_GAME_LOGIC.goToDefaultNextBlock();
    return false;
  }

  setupVersion3AndAbove() {
    const isSTTVersion3AndAbove = Number(CONFIG.STTVersion ?? 2) >= 3;

    if (isSTTVersion3AndAbove) {
      $(document.body).addClass("stt-next");

      /**
       * Config variables that change appearance of question modal
       * - modalTransparency = percentage value from 0 - 100
       * - modalColor        = hex color code
       * - modalPosition     = 'Top [Left,Center,Right], Bottom [Left,Center,Right], True Center'
       */
      const modalTransparency = "100%"; // default should be 100%
      const modalColor = "#fff"; // default should be #fff
      const modalPosition = "Bottom Center"; // default should be Bottom Center

      const newColor = convertHexToRgba(modalColor, modalTransparency);

      $(".question-modal").css("background-color", newColor);
      $(".question-modal").addClass(
        modalPosition.toLowerCase().split(" ").join("-"),
      );
    }
  }
}
